module.exports = __webpack_public_path__ + "img/gd-img.52206b72.png";